import React from 'react';

function Blocks() {
  return (
    <section className="relative">

      {/* Section background (needs .relative class on parent and next sibling elements) */}
      <div className="absolute inset-0 top-0 lg:mt-0 pointer-events-none" aria-hidden="true"></div>

      <div className="relative max-w-6xl mx-auto bg-gray-800 bg-opacity-40 rounded-2xl px-4 sm:px-6 mb-20" 
      data-aos="fade-right" data-aos-offset="200">
      
          <div className="py-12">

            {/* Section header */}
            <div className="max-w-3xl mx-auto text-center pb-12">
              <h2 className="h2 mb-4 text-white text-blue-300">Meis võid alati kindel olla</h2>
            </div>

            {/* Items */}
            <div className="max-w-sm mx-auto grid gap-6 lg:grid-cols-3 items-start lg:max-w-none" 
            data-aos="fade-right" data-aos-offset="250">

              {/* 1st item */}
              <div className="relative flex flex-col items-center p-6 bg-gray-400 rounded shadow-xl">
                <div className="w-16 h-16 p-1 -mt-1 mb-2 bg-blue-600 rounded-full" viewBox="0 0 512 512">
                  <img className="filter invert mx-auto my-2" width="70%" alt="" src={require('../images/icons/envelope.svg').default}/>
                </div>
                
                <h4 className="text-xl font-bold leading-snug tracking-tight mb-1">Kindel kvaliteet</h4>
                <p className="text-gray-900 text-center">Meilt tellitud kleebiste kvaliteedis võid alati kindel olla.</p>
              </div>

              {/* 2nd item */}
              <div className="relative flex flex-col items-center p-6 bg-gray-400 rounded shadow-xl">
                <div className="w-16 h-16 p-1 -mt-1 mb-2 bg-blue-600 rounded-full" viewBox="0 0 512 512">
                  <img className="filter invert mx-auto my-2" width="50%" alt="" src={require('../images/icons/bolt.svg').default}/>
                </div>
                <h4 className="text-xl font-bold leading-snug tracking-tight mb-1">Kiire reageerimine</h4>
                <p className="text-gray-900 text-center">Oleme kättesaadavad ka nädalavahetustel ja riigipühadel.</p>
              </div>

              {/* 3rd item */}
              <div className="relative flex flex-col items-center p-6 bg-gray-400 rounded shadow-xl">
                <div className="w-16 h-16 p-1 -mt-1 mb-2 bg-blue-600 rounded-full" viewBox="0 0 512 512">
                  <img className="filter invert mx-auto my-3" width="70%" alt="" src={require('../images/icons/truck.svg').default}/>
                </div>
                <h4 className="text-xl font-bold leading-snug tracking-tight mb-1">Tasuta transport</h4>
                <p className="text-gray-900 text-center">Toome tellimuse Tallinnas kohale tasuta. Kiirtellimuse puhul juba samal päeval.</p>
              </div>

            </div>
          </div>
      </div>
    </section>
  );
}

export default Blocks;
